import React, { useEffect } from 'react';
import { useState } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import SearchBar from './topSubMenuComponents/SearchBar.js';
import GenPDF from './topSubMenuComponents/genpdf.js'

const TopSubMenu = ({
    mapboxTokenRef,
    globalState,
    globalRefs,
    isInAboutPanel,
    isInInvestorsPanel,
    isInPrivacyPanel,
    isInTacPanel,
    resetAboutPanels,
    isInSettings,
}) => {


    let selectedMetric = globalState.selectedMetric;
    let longstandingGeoJSONRef = globalRefs.longstandingGeoJSONRef;
    const scenarioFeatures = longstandingGeoJSONRef.current?.features || [];
    const hasHabitatTypeForScenario = scenarioFeatures.length > 0 && scenarioFeatures.every(
        (feature) => Object.prototype.hasOwnProperty.call(
            feature?.feature_data_simple_timeseries || {},
            'HabitatType'
        )
    );
    const scenarioUnavailableReason = scenarioFeatures.length === 0
        ? 'Load a map with Habitat Type data to use scenario modelling.'
        : 'This map does not include the required “Habitat Type” property for every feature.';
    let selectedYearEditing = globalState.selectedYearEditing;
    let setFeatureList = globalState.setFeatureList;
    let setActiveFeatureId = globalState.setActiveFeatureId;
    let multuGroupSelectedArray = globalState.multuGroupSelectedArray;
    let polygonCustomLayerRef = globalRefs.polygonCustomLayerRef;
    let setIsRealmLeftClickedInfoVisible = globalState.setIsRealmLeftClickedInfoVisible;
    let setClickedInfoTab = globalState.setClickedInfoTab;
    let setisMenuLoadClick = globalState.setisMenuLoadClick;
    let setisLeftSubDrawerOpen = globalState.setisLeftSubDrawerOpen;
    let isLeftSubDrawerOpen = globalState.isLeftSubDrawerOpen;
    let setScenarioModelingModeActive = globalState.setScenarioModelingModeActive;

    let singleFeatureEditMode = globalState.singleFeatureEditMode;
    let setSingleFeatureEditMode = globalState.setSingleFeatureEditMode;

    // Loading state
    let isLoading = globalState.isLoading;

    useEffect(() => {
        if (!polygonCustomLayerRef.current) return;
        polygonCustomLayerRef.current.alterpolygonSingleFeatureEditMode(
            singleFeatureEditMode
        );
    }, [singleFeatureEditMode]);

    useEffect(() => {
        if (!singleFeatureEditMode) return;
        globalState.setMultuGroupSelectedArray((prev) => {
            if (prev.length <= 1) return prev;
            return [prev[prev.length - 1]];
        });
    }, [singleFeatureEditMode]);

    const backToMap = () => {
        resetAboutPanels();
    }

    const closeClickedInfoRealm = () => {
        setClickedInfoTab("DATA");

        if (Array.isArray(multuGroupSelectedArray)) {
            multuGroupSelectedArray.forEach(skylarkId => {
                polygonCustomLayerRef.current
                    .removedSkylarkIdFromsetMultuGroupSelectedArrayPoints(skylarkId);
            });
        }

        setIsRealmLeftClickedInfoVisible(false);
        setFeatureList([]);
        setActiveFeatureId(null);
    };

    let noData = true;

    if (!longstandingGeoJSONRef.current) {
        noData = true;
    } else {
        noData = false;
    }

    return (
        <div
            className={`top_Submenu ${isInAboutPanel ||
                isInInvestorsPanel ||
                isInPrivacyPanel ||
                isInTacPanel ||
                isInSettings
                ? 'inabout'
                : ''
                } ${isLoading ? 'top_Submenu_loading' : ''}`}
        >

            <BrowserView>

                {isInAboutPanel ||
                    isInInvestorsPanel ||
                    isInPrivacyPanel ||
                    isInTacPanel ||
                    isInSettings ? (

                    <div className='topSubmenuBack'>
                        <button
                            className='topSubmenuBackButton'
                            onClick={backToMap}
                        >
                            Back to Map
                        </button>
                    </div>

                ) : (

                    <div>

                        <button
                            style={{
                                position: 'relative',
                                paddingTop: '10px',
                                paddingLeft: '20px',
                                left: '20px',
                                top: '8px',
                                paddingRight: '20px',
                                color: '#fff',
                                paddingBottom: '10px',
                                borderRadius: '3px',
                                zIndex: 10,
                                textAlign: 'center',
                                margin: '0px 10px',
                                backgroundColor: '#29645D',
                                cursor: 'pointer'
                            }}
                            onClick={() => setisMenuLoadClick(true)}
                        >
                            Map Explorer
                        </button>

                        <GenPDF
                            globalRefs={globalRefs}
                            globalState={globalState}
                        />

                        <SearchBar
                            mapboxTokenRef={mapboxTokenRef}
                            globalRefs={globalRefs}
                            globalState={globalState}
                        />

                        {/* <span title={hasHabitatTypeForScenario ? '' : scenarioUnavailableReason} style={{ position: 'absolute', right: '205px', top: '7px', zIndex: 10 }}>
                            <button
                                type="button"
                                disabled={singleFeatureEditMode || !hasHabitatTypeForScenario}
                                aria-pressed={isLeftSubDrawerOpen}
                                style={{
                                    width: '180px',
                                    height: '34px',
                                    padding: '0 8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    color: '#fff',
                                    backgroundColor: singleFeatureEditMode || !hasHabitatTypeForScenario
                                        ? '#E6E4ED'
                                        : isLeftSubDrawerOpen ? '#D63384' : '#29645D',
                                    border: singleFeatureEditMode || !hasHabitatTypeForScenario
                                        ? '2px solid #E6E4ED'
                                        : 'none',
                                    cursor: singleFeatureEditMode || !hasHabitatTypeForScenario ? 'not-allowed' : 'pointer',
                                    opacity: singleFeatureEditMode || !hasHabitatTypeForScenario ? 0.65 : 1,
                                    transition: 'background-color 0.2s ease',
                                }}
                                onClick={() => {
                                    const nextIsOpen = !isLeftSubDrawerOpen;
                                    setisLeftSubDrawerOpen(nextIsOpen);
                                    setScenarioModelingModeActive(nextIsOpen);
                                }}
                            >
                                <span>Scenario Modelling</span>
                                <span
                                    style={{
                                        position: 'relative',
                                        width: '28px',
                                        height: '14px',
                                        borderRadius: '12px',
                                        backgroundColor: 'rgba(255,255,255,0.25)',
                                        flexShrink: 0,
                                    }}
                                >
                                    <span
                                        style={{
                                            position: 'absolute',
                                            top: '2px',
                                            left: '2px',
                                            width: '10px',
                                            height: '10px',
                                            borderRadius: '50%',
                                            backgroundColor: '#fff',
                                            transform: isLeftSubDrawerOpen
                                                ? 'translateX(14px)'
                                                : 'translateX(0)',
                                            transition: 'transform 0.2s ease',
                                        }}
                                    />
                                </span>
                            </button>
                        </span> */}

                        <button
                            className={`emptySelectionButton ${multuGroupSelectedArray.length > 0 ? 'is-active' : 'is-inactive'}`}
                            style={{
                                position: 'relative',
                                paddingTop: '10px',
                                paddingLeft: '20px',
                                left: '50%',
                                top: '-26.5px',
                                transform: 'translateX(-50%)',
                                paddingRight: '20px',
                                color: '#fff',
                                paddingBottom: '10px',
                                borderRadius: '3px',
                                zIndex: 10,
                                textAlign: 'center',
                                margin: '0px 10px',
                                backgroundColor: multuGroupSelectedArray.length > 0
                                    ? 'black'
                                    : '#E6E4ED',
                                cursor: multuGroupSelectedArray.length > 0
                                    ? 'pointer'
                                    : 'not-allowed',
                                pointerEvents: multuGroupSelectedArray.length > 0
                                    ? 'auto'
                                    : 'none',
                            }}
                            onClick={closeClickedInfoRealm}
                        >
                            Empty Selection
                        </button>

                        <button
                            disabled={isLeftSubDrawerOpen}
                            onClick={() => {
                                if (!isLeftSubDrawerOpen) {
                                    setSingleFeatureEditMode(!singleFeatureEditMode);
                                }
                            }}
                            style={{
                                position: "absolute",
                                right: "13px",
                                top: "7px",
                                zIndex: 10,
                                width: "180px",
                                height: "34px",
                                padding: "0 8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                backgroundColor: isLeftSubDrawerOpen
                                    ? "#E6E4ED"
                                    : singleFeatureEditMode ? "#c97b06" : "#29645D",
                                border: isLeftSubDrawerOpen ? "2px solid #E6E4ED" : "none",
                                cursor: isLeftSubDrawerOpen ? "not-allowed" : "pointer",
                                opacity: isLeftSubDrawerOpen ? 0.65 : 1,
                                transition: "background-color 0.2s ease"
                            }}
                            className="singleFeatureModeToggle"
                        >
                            <span
                                style={{
                                    color: "#fff"
                                }}
                            >
                                {singleFeatureEditMode ? "Single Feature Mode" : "Single Feature Mode"}
                            </span>

                            <span
                                className="singleFeatureModeTrack"
                                style={{
                                    position: "relative",
                                    width: "28px",
                                    height: "14px",
                                    borderRadius: "12px",
                                    backgroundColor: "rgba(255,255,255,0.25)",
                                    flexShrink: 0
                                }}
                            >
                                <span
                                    className="singleFeatureModeThumb"
                                    style={{
                                        position: "absolute",
                                        top: "2px",
                                        left: "2px",
                                        width: "10px",
                                        height: "10px",
                                        borderRadius: "50%",
                                        backgroundColor: "#fff",
                                        transform: singleFeatureEditMode
                                            ? "translateX(14px)"
                                            : "translateX(0)",
                                        transition: "transform 0.2s ease"
                                    }}
                                />
                            </span>
                        </button>


                    </div>
                )}

            </BrowserView>

        </div>
    );
};

export default TopSubMenu;
